module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/es-abstract/helpers/mod.js
// module id = 637
// module chunks = 168707334958949